import React from 'react';

function MarkerText(props) {
  var { text, color, markerStyle, ...other } = props;
  
  color = '#' + color;

  if (markerStyle === undefined) {
    markerStyle = {};
  }

  markerStyle.backgroundColor = color;

  return (
    <p {...other}><span className='marker' style={markerStyle}/>{text}</p>
  );
}

export default MarkerText;


// WEBPACK FOOTER //
// ./src/components/MarkerText.js